/**
 * New Mega Menu JavaScript
 * Handles tab switching and hover functionality for mega menu dropdown
 */

class MegaMenuNew {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupMegaMenus());
    } else {
      this.setupMegaMenus();
    }
  }

  setupMegaMenus() {
    const megaMenus = document.querySelectorAll('.mega-menu');
    
    megaMenus.forEach((menu) => {
      this.setupHover(menu);
      this.setupTabs(menu);
    });
  }

  setupHover(menu) {
    const summary = menu.querySelector('summary');
    const content = menu.querySelector('.mega-menu__content');
    
    if (!summary || !content) return;
    
    let hoverTimeout;
    let isHovering = false;
    
    // Show mega menu on hover
    summary.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      isHovering = true;
      menu.setAttribute('open', '');
      // Use requestAnimationFrame to ensure DOM is updated before activating tab
      requestAnimationFrame(() => {
        this.activateFirstTab(menu);
      });
    });
    
    // Keep mega menu open when hovering over content
    content.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      isHovering = true;
    });
    
    // Hide mega menu when mouse leaves
    const hideMegaMenu = () => {
      isHovering = false;
      hoverTimeout = setTimeout(() => {
        if (!isHovering) {
          menu.removeAttribute('open');
        }
      }, 200);
    };
    
    summary.addEventListener('mouseleave', hideMegaMenu);
    content.addEventListener('mouseleave', hideMegaMenu);
    
    // Ensure first tab is active on open
    menu.addEventListener('toggle', () => {
      if (menu.hasAttribute('open')) {
        requestAnimationFrame(() => {
          this.activateFirstTab(menu);
        });
      }
    });
  }

  activateFirstTab(menu) {
    // Only select actual tab buttons, not direct links
    const firstTab = menu.querySelector('.mega-menu-tab[data-tab-index]');
    
    if (firstTab) {
      const tabIndex = parseInt(firstTab.getAttribute('data-tab-index'));
      const parentIndex = parseInt(firstTab.getAttribute('data-parent-index'));
      
      // Remove active class from all tabs in this menu (only actual tab buttons)
      menu.querySelectorAll('.mega-menu-tab[data-tab-index]').forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      
      // Remove active class from all card containers in this menu
      menu.querySelectorAll('.mega-menu-cards').forEach((c) => {
        c.classList.remove('active');
      });
      
      // Remove active class from all featured cards
      menu.querySelectorAll('.mega-menu-featured-card').forEach((f) => {
        f.classList.remove('active');
      });
      
      // Activate first tab
      firstTab.classList.add('active');
      firstTab.setAttribute('aria-selected', 'true');
      
      // Activate corresponding cards
      const targetCards = menu.querySelector(
        `.mega-menu-cards[data-tab-content="${tabIndex}"][data-parent-index="${parentIndex}"]`
      );
      if (targetCards) {
        targetCards.classList.add('active');
      }
      
      // Activate corresponding featured card
      const targetFeatured = menu.querySelector(
        `.mega-menu-featured-card[data-tab-content="${tabIndex}"][data-parent-index="${parentIndex}"]`
      );
      if (targetFeatured) {
        targetFeatured.classList.add('active');
      }
    }
  }

  setupTabs(menu) {
    // Only select actual tab buttons (with data-tab-index), not direct links
    const tabs = menu.querySelectorAll('.mega-menu-tab[data-tab-index]');
    const cardsContainers = menu.querySelectorAll('.mega-menu-cards');
    const featuredCards = menu.querySelectorAll('.mega-menu-featured-card');
    
    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        
        const tabIndex = parseInt(tab.getAttribute('data-tab-index'));
        const parentIndex = parseInt(tab.getAttribute('data-parent-index'));
        
        // Remove active class from all tabs in this menu (only actual tab buttons)
        menu.querySelectorAll('.mega-menu-tab[data-tab-index]').forEach((t) => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        
        // Remove active class from all card containers in this menu
        cardsContainers.forEach((container) => {
          container.classList.remove('active');
        });
        
        // Remove active class from all featured cards
        featuredCards.forEach((card) => {
          card.classList.remove('active');
        });
        
        // Add active class to clicked tab
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        
        // Show corresponding card container
        const targetCards = menu.querySelector(
          `.mega-menu-cards[data-tab-content="${tabIndex}"][data-parent-index="${parentIndex}"]`
        );
        if (targetCards) {
          targetCards.classList.add('active');
        }
        
        // Show corresponding featured card
        const targetFeatured = menu.querySelector(
          `.mega-menu-featured-card[data-tab-content="${tabIndex}"][data-parent-index="${parentIndex}"]`
        );
        if (targetFeatured) {
          targetFeatured.classList.add('active');
        }
      });
    });
  }
}

// Initialize on page load
if (typeof window !== 'undefined') {
  new MegaMenuNew();
}

// Re-initialize if new content is loaded (for dynamic content)
if (typeof document !== 'undefined') {
  document.addEventListener('shopify:section:load', () => {
    new MegaMenuNew();
  });
  
  // Handle window resize for responsive behavior
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Recalculate mega menu positioning on resize
      const megaMenus = document.querySelectorAll('.mega-menu[open]');
      megaMenus.forEach((menu) => {
        const content = menu.querySelector('.mega-menu__content');
        if (content) {
          // Force reflow to recalculate positioning
          content.style.display = 'none';
          requestAnimationFrame(() => {
            content.style.display = '';
          });
        }
      });
    }, 100);
  });
}

